<template>
  <div
    class="map-container"
  >
    <div
      v-show="$store.state.displayMap"
      id="map"
      ref="map"
      class="map"
    >
      <!-- <mouse-hover-box
        v-if="false"
        id="mhb"
      /> -->
      <!-- FEATURE add box that mouse position targets to, display in desktop only -->
      <map-controls />
      <client-logo />
    </div>
    <v-snackbar
      v-model="showWarningMinZoom"
      class="mt-6"
      :timeout="snacktimeout"
      absolute
      bottom
      color="warning"
    >
      {{ $t('olMap.minZoomReached') }}
    </v-snackbar>
    <v-snackbar
      v-model="showWarningMaxZoom"
      class="mt-6"
      :timeout="snacktimeout"
      absolute
      bottom
      color="warning"
    >
      {{ $t('olMap.maxZoomReached') }}
    </v-snackbar>
  </div>
</template>
<script>

import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';
import JSPDF from 'jspdf';
import center from '@turf/center';
import distance from '@turf/distance';

import { EventBus } from '../../event-bus';
import { MapboxFactory } from '../../factory/mapbox/MapboxFactory';
// import hbfm1 from './hbf-1.json';
import MapControls from './MapControls.vue';
import ClientLogo from '../ClientLogo.vue';
import PointOfInterest from '../../model/PointOfInterest';

const QRCode = require('qrcode');

const displayed = true;

export default {
  name: 'MapboxBox',
  components: {
    MapControls,
    ClientLogo,
  },
  props: {
    rotateableMap: { type: Boolean, required: false, default: true },
  },
  data() {
    return {
      displayed,
      baseColor: this.$appConfig.baseColor,
      mousePositionAccuracy: this.$appConfig.mousePositionAccuracy,
      ftrs: [],
      position: [],
      // currentView: new View(),
      positionFeature: {},
      accuracyFeature: {},
      bingMapsTileLayer: {},
      baseMapLayer: {},
      label: '',
      sublabel: '',
      mousepositionControl: {},
      showWarningMaxZoom: false,
      showWarningMinZoom: false,
      snacktimeout: 1500,
      scalelineControl: {},
      map: {},
      selectionMarker: [],
      mapBound: false,
      layerList: [],
      defaultAttrs: this.$appConfig.information.mapData,
      responsibility: this.$appConfig.responsibility.name,
      eqlength: (40075.016686 * 1000) / 256,
      chartMarkers: {},
      chartMarkersOnScreen: {},
      chartLayers: [],
      additionalPrintText: this.$appConfig.additionalPrintText,
      additionalPrintTextFontSize: this.$appConfig.additionalPrintTextFontSize,
      logo: this.$appConfig.logo,
      mapSelectionSettings: this.$appConfig.mapSelectionSettings,
    };
  },
  computed: {
    rotation() {
      if (Object.entries(this.map).length === 0 && this.map.constructor === Object) {
        return 0;
      }
      return this.map.getBearing();
      // return this.map.getBearing();
      // this.map.resetNorth();
    },
    currentZoom() {
      if (this.mapBound) {
        return this.map.getZoom();
      }
      return undefined;
    },
  },
  watch: {
    rotation(nv) {
      EventBus.$emit('rotation', nv);
    },
    currentZoom(nv) {
      if (nv >= this.map.getMaxZoom()) {
        this.showWarningMaxZoom = true;
      }
      if (nv <= this.map.getMinZoom()) {
        this.showWarningMinZoom = true;
      }
    },
  },
  created() {
  },
  mounted() {
    const me = this;
    let mapBounds = [];
    if (me.$appConfig.boundaries) {
      mapBounds = [
        [
          me.$appConfig.boundaries.west,
          me.$appConfig.boundaries.south,
        ], [
          me.$appConfig.boundaries.east,
          me.$appConfig.boundaries.north,
        ],
      ];
    }
    me.map = new mapboxgl.Map({
      container: 'map', // container id
      style: me.$mapboxStyle, // stylesheet location
      center: me.$appConfig.mapCenter, // starting position [lng, lat]
      zoom: me.$appConfig.mapZoom, // starting zoom
      minZoom: me.$appConfig.minZoom,
      maxZoom: me.$appConfig.maxZoom,
      snapToNorth: true,
      ...((mapBounds.length > 0) && { maxBounds: mapBounds }),
      maxPitch: (me.$appConfig.show3dOption) ? 60 : 0,
    });

    // TEMP
    me.map.addControl(new mapboxgl.NavigationControl({
      visualizePitch: true,
    }));
    const geolocControl = new mapboxgl.GeolocateControl({
      positionOptions: {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 7500,
      },
      trackUserLocation: true,
    });
    me.map.addControl(geolocControl);
    me.map.addControl(new mapboxgl.ScaleControl());
    me.map.addControl(new mapboxgl.FullscreenControl());
    // END TEMP
    this.$map = me.map;
    this.mapBound = true;
    this.checkIfScalesAvailable();
    me.map.once('load', () => {
      this.$appConfig.mapLayers.forEach((lConf) => {
        this.emitPointResolution();
        const layer = MapboxFactory.getInstance(lConf);
        this.layerList.push(layer);
        me.map.addSource(lConf.lid, layer.source);
        this.addToLegend(lConf, layer);
        layer.layers.forEach((mapboxLayer) => {
          // for each layer do
          if (mapboxLayer.imageSource === undefined) {
            if (mapboxLayer.chartOptions !== undefined) {
              this.initCharts(mapboxLayer);
            }
            if (mapboxLayer.id.includes('cluster')) {
              me.map.on('click', mapboxLayer.id, (e) => {
                const features = me.map.queryRenderedFeatures(e.point);
                const clusterId = features[0].properties.cluster_id;
                if (clusterId !== undefined) {
                  me.map.getSource(lConf.lid).getClusterExpansionZoom(
                    clusterId,
                    (err, zoom) => {
                      if (err) return;
                      me.map.easeTo({
                        center: features[0].geometry.coordinates,
                        zoom,
                      });
                    },
                  );
                }
              });
              // touch block might be unneccessary
              me.map.on('touch', mapboxLayer.id, (e) => {
                const features = me.map.queryRenderedFeatures(e.point);
                if (features.length > 0) {
                  const clusterId = features[0].properties.cluster_id;
                  if (clusterId !== undefined) {
                    me.map.getSource(lConf.lid).getClusterExpansionZoom(
                      clusterId,
                      (err, zoom) => {
                        if (err) return;
                        if (!features[0].geometry.coordinates.isNaN()) {
                          me.map.easeTo({
                            center: features[0].geometry.coordinates,
                            zoom,
                          });
                        }
                      },
                    );
                  }
                }
              });
            }
            me.map.addLayer(mapboxLayer);
            if (layer.meta.isDefaultBaseLayer === true) {
              me.map.setLayoutProperty(mapboxLayer.id, 'visibility', 'visible');
              me.$store.commit('addToHtmlAttributionList', `${layer.meta.name}: ${layer.meta.attributionHTML}`);
              me.$store.commit('addToTextAttributionList', `${layer.meta.name}: ${layer.meta.attributionText}`);
            }
          } else {
            me.map.loadImage(mapboxLayer.imageSource, (error, image) => {
              if (error) {
                throw error;
              }
              me.map.addImage(mapboxLayer.imageSource, image);
              if (mapboxLayer.id.includes('cluster')) {
                me.map.on('click', mapboxLayer.id, (e) => {
                  const features = me.map.queryRenderedFeatures(e.point);
                  const clusterId = features[0].properties.cluster_id;
                  if (clusterId !== undefined) {
                    me.map.getSource(lConf.lid).getClusterExpansionZoom(
                      clusterId,
                      (err, zoom) => {
                        if (err) return;
                        me.map.easeTo({
                          center: features[0].geometry.coordinates,
                          zoom,
                        });
                      },
                    );
                  }
                });
                me.map.on('touch', mapboxLayer.id, (e) => {
                  const features = me.map.queryRenderedFeatures(e.point);
                  const clusterId = features[0].properties.cluster_id;
                  if (clusterId !== undefined) {
                    me.map.getSource(lConf.lid).getClusterExpansionZoom(
                      clusterId,
                      (err, zoom) => {
                        if (err) return;
                        me.map.easeTo({
                          center: features[0].geometry.coordinates,
                          zoom,
                        });
                      },
                    );
                  }
                });
              }
              me.map.addLayer(mapboxLayer);
              if (layer.meta.isDefaultBaseLayer === true) {
                me.map.setLayoutProperty(mapboxLayer.id, 'visibility', 'visible');
                me.$store.commit('addToHtmlAttributionList', layer.meta.attributionHTML);
                me.$store.commit('addToTextAttributionList', layer.meta.attributionText);
              }
            });
          }
        });
        EventBus.$emit('layer-meta', layer);
      });
      EventBus.$emit('mapbox-map-mounted', me.map);
    });
    me.map.on('mousedown', () => {
      this.emitPointResolution();
      EventBus.$emit('map-movement');
    });
    me.map.on('touchstart', () => {
      this.emitPointResolution();
      EventBus.$emit('map-movement');
    });
    me.map.on('click', (e) => {
      this.emitPointResolution();
      // click on map and select feature
      this.removeAllMarkers();
      this.$store.commit('closeDetailView');
      const features = me.map.queryRenderedFeatures(e.point);
      this.selectFeature(this.getNearestFeatureFromFeatureList(e.lngLat, features));
    });
    me.map.on('touch', (e) => {
      this.emitPointResolution();
      // click on map and select feature
      this.removeAllMarkers();
      const features = me.map.queryRenderedFeatures(e.point);
      this.selectFeature(this.getNearestFeatureFromFeatureList(e.lnglat, features));
    });
    this.map.on('data', (e) => {
      // if (e.sourceId !== 'donut' || !e.isSourceLoaded) return;

      this.map.on('move', this.updateCharts);
      this.map.on('moveend', this.updateCharts);
      this.updateCharts();
    });
    EventBus.$on('zoom-in', () => {
      me.map.zoomIn();
    });
    EventBus.$on('zoom-out', () => {
      me.map.zoomOut();
    });
    EventBus.$on('tilt-map', () => {
      if (me.map.getPitch() === 0) {
        me.map.easeTo({
          pitch: 60,
          duration: 500,
        });
      } else {
        me.map.easeTo({
          pitch: 0,
          duration: 500,
        });
      }
    });
    EventBus.$on('orientation-reset', () => {
      me.map.resetNorthPitch({
        duration: 500,
      });
    });
    EventBus.$on('get-geolocation', () => {
      geolocControl.trigger();
    });
    EventBus.$on('draw-and-goto-marker', (lat, lon) => {
      this.markerAt([lon, lat], '#000');
      this.flyTo([lon, lat]);
      // me.select.getFeatures().clear();
      // me.select.getFeatures().push(feat);
    });
    EventBus.$on('draw-feature', (coords, pan, selectFeature, poi, removeAll = true) => {
      // If the overlay got 'undefined' as the set position param, it will just disappear
      if (removeAll) {
        this.removeAllMarkers(); // clear markers before drawing feature
      }
      if (pan === true) {
        switch (poi.geometry.type) {
          case 'Point':
            this.flyTo(poi.geometry.coordinates);
            break;
          case 'LineString': {
            const { coordinates } = poi.geometry;
            // Pass the first coordinates in the LineString to `lngLatBounds` &
            // wrap each coordinate pair in `extend` to include them in the bounds
            // result. A variation of this technique could be applied to zooming
            // to the bounds of multiple Points or Polygon geomteries - it just
            // requires wrapping all the coordinates with the extend method.
            const lineStringBounds = coordinates.reduce((bounds, coord) => bounds.extend(coord),
              new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

            me.map.fitBounds(lineStringBounds, {
              padding: 20,
            });
          }
            break;
          case 'Polygon': {
            const coordinates = poi.geometry.coordinates[0];
            // Pass the first coordinates in the LineString to `lngLatBounds` &
            // wrap each coordinate pair in `extend` to include them in the bounds
            // result. A variation of this technique could be applied to zooming
            // to the bounds of multiple Points or Polygon geomteries - it just
            // requires wrapping all the coordinates with the extend method.
            const lineStringBounds = coordinates.reduce((bounds, coord) => bounds.extend(coord),
              new mapboxgl.LngLatBounds(coordinates[0], coordinates[0]));

            me.map.fitBounds(lineStringBounds, {
              padding: 20,
            });
          }

            break;
          default:
          // eslint-disable-next-line no-console
            console.warn(`unknown geom type in draw-feature: ${poi.geometry.type}`);
            break;
        }
      }
      if (selectFeature === true) {
        if (poi !== undefined) {
          this.displayFeature(poi);
        } else {
          this.displayFeature(undefined);
        }
        // me.select.getFeatures().clear();
        // me.select.getFeatures().push(feat);
      }
    });
    EventBus.$on('markerAt', (latlon, color, removeAll) => {
      this.markerAt(latlon, color, removeAll);
    });
    EventBus.$on('print', (printSettings) => {
      // const dA = this.defaultAttrs; // TODO find out what this property was for
      const tA = this.$store.getters.textAttributions;
      const { res } = printSettings;
      const PDFHeading = printSettings.printheading;
      const paperdim = printSettings.paper.dim;
      const preMapView = {
        zoom: this.map.getZoom(),
        lat: me.map.getCenter().lat,
        lon: me.map.getCenter().lon,
        containerStyle: this.map.getContainer().style,
        canvasContainerStyle: this.map.getCanvasContainer().style,
      };

      const textScale = 'Maßstab: ~ 1:'/* #### */;
      const textCreated = 'Erstellt am '/* DD.MM.YYYY HH:MM */;
      // TODO adjustable pronoun in next line ('der')
      const textOrigin = 'Geoportal ';// 'Auszug des Geoportals der '/* Kundenname */;

      let vw = paperdim[0] / 100;
      let vh = paperdim[1] / 100;
      const PDFwhitespace = 5;
      let PDFmapsize = [
        paperdim[0] - (2 * PDFwhitespace),
        paperdim[1] - ((2 * PDFwhitespace) + 30)];
      const { orientation } = printSettings;
      if (orientation === 'portrait') {
        vw = paperdim[1] / 100;
        vh = paperdim[0] / 100;
        PDFmapsize = [paperdim[1] - (2 * PDFwhitespace), paperdim[0] - ((2 * PDFwhitespace) + 50)];
      }

      const width = Math.round((PDFmapsize[0] * res) / 25.4); // 25.4mm per inch
      const height = Math.round((PDFmapsize[1] * res) / 25.4);
      // TODO const preSize = me.map.getSize();
      // TODO const extent = me.map.getView().calculateExtent(preSize);

      const mapPointResolution = this.getCenterResolution();
      const mapResolutionFactor = this.getCenterResolutionEq() / mapPointResolution;

      const printPointResolution = (printSettings.scales.scalenumber * 25.4) / (res * 1000);
      const printResolutionAtEquator = mapResolutionFactor * printPointResolution;
      const printZoom = this.getZoomForResolution(printResolutionAtEquator);
      let maprotation = this.map.getBearing();
      while (maprotation < 0) {
        maprotation += 2 * Math.PI;
      }
      while (maprotation > (2 * Math.PI)) {
        maprotation -= 2 * Math.PI;
      }
      maprotation %= (2 * Math.PI);
      maprotation *= (180 / Math.PI);
      this.map.getContainer().style.width = `${width}px`;
      this.map.getContainer().style.height = `${height}px`;
      this.map.getCanvasContainer().style.width = `${width}px`;
      this.map.getCanvasContainer().style.height = `${height}px`;
      this.map.resize();
      EventBus.$emit('start-print-mode');
      this.map.setZoom(printZoom);

      me.map.once('idle', () => {
        const canvas = this.map.getCanvas();
        const data = canvas.toDataURL('image/jpeg');
        const pdf = new JSPDF(printSettings.orientation, 'mm', printSettings.paper.format);

        pdf.addImage(data, 'JPEG', PDFwhitespace, PDFwhitespace, PDFmapsize[0], PDFmapsize[1]);
        const date = new Date();
        pdf.rect(PDFwhitespace, PDFwhitespace, PDFmapsize[0], PDFmapsize[1], 'S');
        pdf.setFontSize(18);
        pdf.text(PDFHeading, (3 * PDFwhitespace), (3 * PDFwhitespace));
        if (orientation === 'landscape') {
          pdf.setFontSize(10);
          pdf.text(`${textScale}${printSettings.scales.scalenumber}`, PDFwhitespace, (100 * vh) - (35 - PDFwhitespace));
          pdf.text(`${textCreated}${this.pad(date.getDate())}.${this.pad(date.getMonth() + 1)}.${date.getFullYear()} ${this.pad(date.getHours())}:${this.pad(date.getMinutes())}`, PDFwhitespace, (100 * vh) - (31 - PDFwhitespace));
          pdf.text(`${textOrigin}${this.responsibility}.`, PDFwhitespace, (100 * vh) - (27 - PDFwhitespace));
          if (this.additionalPrintText) {
            const maxLineWidth = 100;
            if (this.additionalPrintTextFontSize) {
              pdf.setFontSize(this.additionalPrintTextFontSize);
            }
            const textLines = pdf.splitTextToSize(this.additionalPrintText, maxLineWidth);
            pdf.text(textLines, PDFwhitespace, (100 * vh) - (21 - PDFwhitespace));
          }
          pdf.setFontSize(8);
          // print URL
          // pdf.text(`${window.location.href}`, PDFwhitespace, (100 * vh) - (10 - PDFwhitespace));
          // print host
          // let attrPosition = 0;
          // for (let i = 0; i < dA.length; i += 1) {
          //   pdf.text(dA[i], (50 * vw) + PDFwhitespace, ((100 * vh) - (5 + (3 * i))));
          //   attrPosition = (100 * vh) - (5 - (3 * tA.length));
          // }
          for (let i = 0; i < tA.length; i += 1) {
            pdf.text(tA[i], (50 * vw) + PDFwhitespace, (100 * vh) - (5 + (3 * i)));
          }
          /*
          // TODO add client's logo into print. the following lines should work, but they don't
          const reader = new FileReader();
          const blob = new File(['logo'], `../../../public/${this.logo}`);
          const img = reader.readAsDataURL(blob);
          const logo = `data:image/png;base64,${img}`;
          console.log('base64 client logo', `../../../public/${this.logo}`, img);
          // TODO Convert Image to base64 and add it
          pdf.addImage(logo, 'png', PDFwhitespace, PDFwhitespace, 100, 100);
          */
          QRCode.toDataURL(window.location.href, (err, url) => {
            pdf.addImage(url, 'PNG', (100 * vw) - 25, (100 * vh) - 25, 20, 20);
          });
          const northarrowPNG = 'iVBORw0KGgoAAAANSUhEUgAAAD8AAABxCAYAAABiDXvDAAAACXBIWXMAABcRAAAXEQHKJvM/AAAF/klEQVR4nO1cv48cNRT2Q0eR6pYu3R6hRdym5qQ7KgqKrIRQBE2WHolDNDSIBIHSLqKNlE1Dy+UvYCPR36Wgo9irKLNprjmUh5w8J95Ze2yP/Z5n2fska3/MeOxvnu3Pfn4zgIhqW/HW1jK/Ir/FuCK/rahKHgB+q1l+NfIAsKeU+hwADmrVoablx/T5ba0KVJvkAMBCKTVUSv2LiG/XqEMVywPAiIhr7ADA7Rr1qNXsjxu/f65RiSrNHgCWSqld6y9ERHFDiBcIABOL+NM3f8MD6brUaPZmlNfEl9b/n0hXRJQ8afst+jltHL4OAENHNjZIW35sfT9xHG/eEFZIk5/Q5yNEXDqOfyxZGTHypO379NNldY1rkpovaXlj9XNE9JHX+E6oPlXItxFXVutghwh5ABhb2j4Lnw73BaolZnlj9aeIeJZwPivYyQPAwNL2ptUHnmwimi9heduKTfJt/ft7pvq8hiT5xx5t9+EL7oqxkqfprLFuaKBr4hq3i4vb8mbd/jyg7T78ylk5bvJmLp9qdYP3y1ZnFWzkSdvNiN2V/A6n5nNa3lj9PFLbffiMq4Is5Enb79BP5zKVFjoxeI9L87ksH1q3q5YJjgssms9F3ozyWtsXBa73aYFrrKE4+Ya2d5E3FwYcms9heTOj09redZR34aeC13oJTvIhq+8lXvfDjvXxoih5ADiytD3kjEwlrzW/udOThdKWt11VOdruw1clL1aMPGl77nQ2hBslNb+k5VNcVapDs9eAkppfkrxp8k8itb0LeVVyW6sIedL2Q/rJ1eQNrpfS/FKWN339ecLEpqvlValQliL781aIid6GivK8AkBOwUVCWbIt3wgx4W7yBmVCWbTlcxIR1l8WsddRSh1Rnpz0d27dS/R5099LLWJicSP3AlnkGyEmKXvrRznlvik+L5Ql1/KvQ0wS1+05I72NLM3vTD4QYhJCrAsrhKxtrRzLx7iq1tBwdpRA51CWHPKhEBMfii5Ls0JZukgENVsjU+OEfAMKP8uVuWa63YlHR/LTVG2nfHcZiOt0KkneWG+akGePibhOL0QmOYkhJjY4p77dQlk6WP2E7vZZQp5jRqub9A9rs6cByxR2HJlnJEDcpCEneduCg8ibtRAk/4CT/BkVchJ5/lyQuE4XLOQbo3VQ262lrnQ64CBvtH0Zce6kEnFM0fwU8qbvtmp7ZeI6XRYlT4sYc/FRy3kjpulrarpfknzQVdUj4hjr4oohHtT2nhE3Kaj5MeTtPry3IcQxRvNjyHu1vcfEdXqWRb6h7ZMNIm5Sq+aHyJv193IDies0zyFvtH22gcQxpPltxO1dldEGEjfJu/psI7+i7TTqbxpxbNN85y4thZgsyGNzj74/TPCRGG+ueVD4mQ5aSMiv9/rfoe/GzZ0SsWlDE3wXEc/Xj4S1vW09fqnvLC1d9Vr/g5C85CR9fSpnTuVeRlrfqfk+8r51uC7sVM+dU70mjDdkSPU5bbkZThdXSNt1ulBK/Z6yTq58Mw6ovhcNHmv1d2X+0bLwRhAO3AjN44W+Ic3jO44B4q9aby8pDUT8Uyl1U70axNciOa7eh7et2Gryrj7fGQAwb+Sd5cTcU6TXyv47IpYIaXl1/ZJ93hNbd7NrBDaFsP9h/4eI0LmCDUg0+zlNl3sHCfK7FcLUoiA14B0CwF2hsqIhOdr/QH24N5CWupM+9X9p8ru0YuwFuMk/dvy3DwCir4HygZv81HMDvqbYnqqQemfGugtJqRlFY1YDO3mKzhzTIyg2quu/yIBH01tX2Knu/1JPZ6xBbLSnBc4jx6E7FLcvDmmpO7bc2TamCW9SKAZR8tT/J57+P5OeAIk7M6j/u5r5/v/9NZAvQS8M+sVxSLT/V3NjIaKv/z+U6v+1fXgu/VdSC6Cq5OmJLFczH0o8nVnde0v9/57j0C2G53FWwO3A/AgRo5aw5Pk9DJ23aQ7MWPj6Pxt6Q95aAImhVzs21EW+kSqvd9tViOhzgBRHX/fqfA6Qouglean+X3Sj0hFxlfKM7Qr0AggAvmR7+7FS6j9qJa39qP+ysQAAAABJRU5ErkJggg==';
          // TODO rotate north arrow by maprotation
          // jspdf's rotation function does not work
          // TEMP
          if (maprotation === 0) {
            pdf.addImage(`data:image/png;base64,${northarrowPNG}`, (100 * vw) - (4 * PDFwhitespace), (2 * PDFwhitespace), 10, 15, 'North Arrow', 'NONE', maprotation);
          }
        }
        if (orientation === 'portrait') {
          pdf.setFontSize(10);
          pdf.text(`${textScale}${printSettings.scales.scalenumber}`, PDFwhitespace, (100 * vh) - (55 - PDFwhitespace));
          pdf.text(`${textCreated}${this.pad(date.getDate())}.${this.pad(date.getMonth() + 1)}.${date.getFullYear()} ${this.pad(date.getHours())}:${this.pad(date.getMinutes())}`, PDFwhitespace, (100 * vh) - (51 - PDFwhitespace));
          pdf.text(`${textOrigin}${this.responsibility}.`, PDFwhitespace, (100 * vh) - (47 - PDFwhitespace));
          if (this.additionalPrintText) {
            const maxLineWidth = 95;
            if (this.additionalPrintTextFontSize) {
              pdf.setFontSize(this.additionalPrintTextFontSize);
            }
            const textLines = pdf.splitTextToSize(this.additionalPrintText, maxLineWidth);
            pdf.text(textLines, (50 * vw) + PDFwhitespace, (100 * vh) - (55 - PDFwhitespace));
          }
          pdf.setFontSize(8);
          // for (let i = 0; i < dA.length; i += 1) {
          //   pdf.text(dA[i], PDFwhitespace, (100 * vh) - (30 + (3 * i)));
          // }
          for (let i = 0; i < tA.length; i += 1) {
            pdf.text(tA[i], PDFwhitespace, (100 * vh) - (27 + (3 * i)));
          }
          // TODO base64 see landscape
          QRCode.toDataURL(window.location.href, (err, url) => {
            pdf.addImage(url, 'PNG', (100 * vw) - 25, (100 * vh) - 25, 20, 20);
          });
          const northarrowPNG = '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';
          // TODO rotate north arrow by maprotation
          // jspdf's rotation function does not work
          // TEMP
          if (maprotation === 0) {
            pdf.addImage(`data:image/png;base64,${northarrowPNG}`, (100 * vw) - (4 * PDFwhitespace), (2 * PDFwhitespace), 10, 15, 'North Arrow', 'NONE', maprotation);
          }
        }
        // Scaleline
        pdf.setFontSize(6);
        pdf.text(printSettings.scales.scaletext2cm, (PDFwhitespace + 10), (PDFmapsize[1] + PDFwhitespace - 3), 'center');
        pdf.lines([[0, 0], [20, 0], [0, 1], [-20, 0]], (PDFwhitespace + 1), (PDFmapsize[1] + 3), [1, 1], 'S', true);
        pdf.lines([[0, 0], [5, 0], [0, 1], [-5, 0]], (PDFwhitespace + 1), (PDFmapsize[1] + 3), [1, 1], 'F', true);
        pdf.lines([[0, 0], [5, 0], [0, 1], [-5, 0]], (PDFwhitespace + 11), (PDFmapsize[1] + 3), [1, 1], 'F', true);
        // cm lines
        /*
        pdf.setDrawColor(0, 0, 225);
        for (let i = 5; i < 300; i += 10) {
          pdf.lines([[0, 0], [300, 0]], 0, i, [1, 1], 'S', false);
          pdf.lines([[0, 0], [0, 300]], i, 0, [1, 1], 'S', false);
        }
        pdf.setDrawColor(0);
        */
        /* ****** */
        pdf.save(`mapedit_portal-${date.getFullYear()}${this.pad(date.getMonth() + 1)}${this.pad(date.getDate())}-${this.pad(date.getHours())}${this.pad(date.getMinutes())}${this.pad(date.getSeconds())}.pdf`);
        // resetting map

        this.map.getContainer().style = preMapView.containerStyle;
        this.map.getCanvasContainer().style = preMapView.canvasContainerStyle;
        this.map.resize();
        this.map.setZoom(preMapView.zoom);
        EventBus.$emit('end-print-mode');
      });
    });

    // if lat, lon and zoom are defined in the url we jump to the coordinates
    if (me.$route.query.lat !== undefined && me.$route.query.lon !== undefined
        && me.$route.query.z !== undefined) {
      const lat = parseFloat(me.$route.query.lat);
      const lon = parseFloat(me.$route.query.lon);
      const z = parseFloat(me.$route.query.z, 10);

      if (!Number.isNaN(lat) && !Number.isNaN(lon) && !Number.isNaN(z)) {
        me.map.jumpTo({ center: [lon, lat], zoom: z });
      }
    }

    me.map.on('moveend', () => {
      this.emitPointResolution();
      me.$router.replace({
        query: {
          lat: me.map.getCenter().lat,
          lon: me.map.getCenter().lng,
          z: me.map.getZoom(),
          layers: me.$route.query.layers,
        },
      }).catch(() => {
        /**
         *  If the website is refreshed at the mapcenter, the router url is equals to the current
         *  vuerouter path
         *  To avoid a error caused by "NavigationDuplicated"
         *  we just catch the error and do nothing
        */
      });
    });
  },
  methods: {
    flyTo(latlon) {
      this.map.flyTo({
        center: latlon,
        bearing: 0,
        pitch: 0,
        duration: 750,
      });
    },
    easeTo(latlon) {
      this.map.easeTo({
        center: latlon,
        bearing: 0,
        pitch: 0,
        duration: 750,
      });
    },
    removeAllMarkers() {
      if (this.selectionMarker.length > 0) {
        this.selectionMarker.forEach((m) => {
          m.remove();
        });
      }
    },
    markerAt(latlon, color, removeAll = true) {
      if (removeAll) {
        this.removeAllMarkers();
      }
      const marker = new mapboxgl.Marker({
        color,
      })
        .setLngLat(latlon)
        .addTo(this.map);
      this.selectionMarker.push(marker);
    },
    getFeatureFromFeatureList(featureList) {
      if (!featureList.length) {
        return;
      }
      if (featureList[0].properties.cluster) {
        return;
      }
      return featureList[0];
    },
    getNearestFeatureFromFeatureList(mouse, featurelist) {
      let nearest = featurelist[0];
      let nearestDist = Number.POSITIVE_INFINITY;
      for (let i = 0; i < featurelist.length; i += 1) {
        const c = center(featurelist[i]);
        const dist = distance([mouse.lng, mouse.lat], c);
        if (dist < nearestDist) {
          nearestDist = dist;
          nearest = featurelist[i];
        }
      }
      return nearest;
    },
    selectFeature(feature) {
      this.removeAllMarkers();
      if (feature === undefined) {
        this.displayFeature(undefined);
        return;
      }
      this.layerList.forEach((layer) => {
        if (layer.meta.lid === feature.source) {
          if (layer.meta.selectable) {
            this.displayFeature(feature);
            // LUCENE change 'wkt' to 'geojson'
            const poi = new PointOfInterest(
              '',
              feature.properties.label,
              feature.properties.sublabel,
              feature.properties.category,
              feature.geometry,
              JSON.parse(feature.properties.meta),
              feature.geometry.coordinates,
            );
            this.$store.commit('setDetailViewOrigin', 'map');
            this.$store.commit('showDetailView', poi);
          }
        }
      });
    },
    displayFeature(feature) {
      const me = this;
      const types = ['point', 'line', 'fill', 'fillextrusion'];
      types.forEach((type) => {
        if (typeof me.map.getLayer(`selectedFeature-${type}`) !== 'undefined') {
          me.map.removeLayer(`selectedFeature-${type}`);
        }
      });
      if (typeof me.map.getSource('selectedFeature') !== 'undefined') {
        me.map.removeSource('selectedFeature');
      }

      if (feature === undefined) return;
      let geometryType = feature.geometry.type;
      if (feature.layer !== undefined) {
        if (feature.layer.paint !== undefined) {
          if (feature.layer.paint['fill-extrusion-height'] !== undefined) {
            geometryType = 'Extrusion';
          }
        }
      }
      me.map.addSource('selectedFeature', {
        type: 'geojson',
        data: feature.geometry,
      });
      const customSelectionColors = this.mapSelectionSettings ? this.mapSelectionSettings.colors : {};
      if (feature instanceof PointOfInterest) {
        switch (geometryType) {
          case 'Point':
            this.markerAt(feature.geometry.coordinates, customSelectionColors.marker ? customSelectionColors.marker : '#000');
            break;
          case 'LineString':
            me.map.addLayer({
              id: 'selectedFeature-line',
              type: 'line',
              source: 'selectedFeature',
              layout: {
                'line-join': 'round',
                'line-cap': 'round',
              },
              paint: {
                'line-color': customSelectionColors.line ? customSelectionColors.line : 'blue',
                'line-width': 2,
              },
            });
            break;
          case 'Polygon':
            me.map.addLayer({
              id: 'selectedFeature-line',
              type: 'line',
              source: 'selectedFeature',
              layout: {
                'line-join': 'round',
                'line-cap': 'round',
              },
              paint: {
                'line-color': customSelectionColors.line ? customSelectionColors.line : 'blue',
                'line-width': 2,
              },
            });
            me.map.addLayer({
              id: 'selectedFeature-fill',
              type: 'fill',
              source: 'selectedFeature',
              paint: {
                'fill-antialias': true,
                'fill-color': customSelectionColors.fill ? customSelectionColors.fill : 'rgba(0,200,100,0.2)',
                'fill-outline-color': customSelectionColors.fillOutline ? customSelectionColors.fillOutline : 'rgba(0,0,0,0)',
              },
            });
            break;
          case 'Extrusion':
            me.map.addLayer({
              id: 'selectedFeature-fillextrusion',
              type: 'line',
              source: 'selectedFeature',
              layout: {
                'line-join': 'round',
                'line-cap': 'round',
              },
              paint: {
                'line-color': customSelectionColors.line ? customSelectionColors.line : 'blue',
                'line-width': 2,
              },
            });
            me.map.addLayer({
              id: 'selectedFeature-fill',
              type: 'fill-extrusion',
              source: 'selectedFeature',
              paint: {
                'fill-extrusion-color': customSelectionColors.fillExtrusion ? customSelectionColors.fillExtrusion : 'blue',
                'fill-extrusion-opacity': 1,
                'fill-extrusion-height': 60,
                'fill-extrusion-base': 0,
              },
            });
            break;
          default:
            // eslint-disable-next-line no-console
            console.warn(`TODO: add new selected style to fit >>${geometryType}<<`);
            break;
        }
      } else {
        switch (geometryType) {
          case 'Point':
            this.markerAt(feature.geometry.coordinates, customSelectionColors.marker ? customSelectionColors.marker : '#000');
            break;
          case 'LineString':
            me.map.addLayer({
              id: 'selectedFeature-line',
              type: 'line',
              source: 'selectedFeature',
              layout: {
                'line-join': 'round',
                'line-cap': 'round',
              },
              paint: {
                'line-color': customSelectionColors.line ? customSelectionColors.line : 'blue',
                'line-width': 2,
              },
            },
            feature.layer.lid);
            break;
          case 'Polygon':
            me.map.addLayer({
              id: 'selectedFeature-line',
              type: 'line',
              source: 'selectedFeature',
              layout: {
                'line-join': 'round',
                'line-cap': 'round',
              },
              paint: {
                'line-color': customSelectionColors.line ? customSelectionColors.line : 'blue',
                'line-width': 2,
              },
            },
            feature.layer.lid);
            me.map.addLayer({
              id: 'selectedFeature-fill',
              type: 'fill',
              source: 'selectedFeature',
              paint: {
                'fill-antialias': true,
                'fill-color': customSelectionColors.fill ? customSelectionColors.fill : 'rgba(0,200,100,0.2)',
                'fill-outline-color': customSelectionColors.fillOutline ? customSelectionColors.fillOutline : 'rgba(0,0,0,0)',
              },
            },
            feature.layer.lid);
            break;
          case 'Extrusion':
            me.map.addLayer({
              id: 'selectedFeature-fillextrusion',
              type: 'line',
              source: 'selectedFeature',
              layout: {
                'line-join': 'round',
                'line-cap': 'round',
              },
              paint: {
                'line-color': customSelectionColors.line ? customSelectionColors.line : 'blue',
                'line-width': 2,
              },
            },
            feature.layer.lid);
            me.map.addLayer({
              id: 'selectedFeature-fill',
              type: 'fill-extrusion',
              source: 'selectedFeature',
              paint: {
                'fill-extrusion-color': customSelectionColors.fillExtrusion ? customSelectionColors.fillExtrusion : 'blue',
                'fill-extrusion-opacity': 1,
                'fill-extrusion-height': 60,
                'fill-extrusion-base': 0,
              },
            },
            feature.layer.lid);
            break;
          default:
            // eslint-disable-next-line no-console
            console.warn(`TODO: add new selected style to fit >>${geometryType}<<`);
            break;
        }
      }
    },
    emitPointResolution() {
      this.$store.commit('updateCurrentMetrePerPixel', this.getCenterResolution());
    },
    getCenterResolution() {
      /* https://docs.microsoft.com/en-us/bingmaps/articles/understanding-scale-and-resolution */
      const a = (Math.cos(this.convertDegToRadiant(this.map.getCenter().lat)) * this.eqlength) / (2 ** (this.currentZoom + 1));
      // https://wiki.openstreetmap.org/wiki/Slippy_map_tilenames#Resolution_and_Scale
      // const f = Math.pow(2, this.currentZoom - 1); // mapbox interprets zoom levels differently
      return a;
    },
    getCenterResolutionEq() {
      return (Math.cos(this.convertDegToRadiant(0)) * this.eqlength) / (2 ** (this.currentZoom + 1));
    },
    getZoomForResolution(printResolutionAtEquator) {
      // const a = Math.log((this.eqlength * Math.cos(this.map.getCenter().lat)) / printResolutionAtEquator);
      // const b = 2 * Math.PI;
      // const d = Math.log(2);
      // const c = (a * b) / d;
      const a = Math.log((this.eqlength * Math.cos(this.convertDegToRadiant(this.map.getCenter().lat))) / printResolutionAtEquator);
      const b = Math.log(2);
      let c = a / b;
      c -= 0.4; // TODO TEMP mamma mia zahl
      return c;
    },
    checkIfScalesAvailable() {
      const { scales } = this.$appConfig.printOptions;
      let list = [];
      list = scales.filter(this.checkIfScaleAvailable);
      EventBus.$emit('available-scales', list);
    },
    checkIfScaleAvailable(scale) {
      const res = 300;
      const mapPointResolution = this.getCenterResolution();
      const mapResolutionFactor = this.getCenterResolutionEq() / mapPointResolution;

      const printPointResolution = (scale * 25.4) / (res * 1000);
      const printResolutionAtEquator = mapResolutionFactor * printPointResolution;
      const printZoom = this.getZoomForResolution(printResolutionAtEquator);
      if (printZoom < this.$appConfig.maxZoom && printZoom > this.$appConfig.minZoom) {
        return scale;
      }
    },
    pad(d) {
      return (d < 10) ? `0${d.toString()}` : d.toString();
    },
    convertDegToRadiant(deg) {
      return (Math.PI / 180) * deg;
    },
    createDonutChart(props, legend) {
      const offsets = [];
      const counts = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const key in props) {
        if (key !== 'cluster' && key !== 'cluster_id' && key !== 'point_count' && key !== 'point_count_abbreviated') {
          counts.push(props[key]);
        }
      }
      let total = 0;
      for (let i = 0; i < counts.length; i += 1) {
        offsets.push(total);
        total += counts[i];
      }
      const fontSize = total >= 10000 ? 26 : total >= 10000 ? 24 : total >= 1000 ? 22 : total >= 100 ? 20 : total >= 10 ? 18 : 16;
      const r = total >= 10000 ? 80 : total >= 10000 ? 65 : total >= 1000 ? 50 : total >= 100 ? 32 : total >= 10 ? 24 : 18; // todo
      const r0 = Math.round(r * 0.6);
      const w = r * 2;
      // let h = `<div><svg width="${w}" height="${w}" viewbox="0 0 ${w} ${w}" text-anchor="middle" style="font: ${fontSize}px sans-serif">`;
      let html =
        '<div><svg width="' +
        w +
        '" height="' +
        w +
        '" viewbox="0 0 ' +
        w +
        ' ' +
        w +
        '" text-anchor="middle" style="font: ' +
        fontSize +
        'px sans-serif">';

      for (let i = 0; i < counts.length; i += 1) {
        html += this.donutSegment(
          offsets[i] / total,
          (offsets[i] + counts[i]) / total,
          r,
          r0,
          legend[i].color,
        );
      }
      // h += `<circle cx="${r} cy="${r}" r="${r0}" fill="white" /><text dominant-baseline="central" transform="translate(${r}, ${r})">${total.toLocaleString()}</text></svg></div>`;
      html +=
        '<circle cx="' +
        r +
        '" cy="' +
        r +
        '" r="' +
        r0 +
        '" fill="white" /><text dominant-baseline="central" transform="translate(' +
        r +
        ', ' +
        r +
        ')">' +
        total.toLocaleString() +
        '</text></svg></div>';
      const el = document.createElement('div');
      el.innerHTML = html;
      return el.firstChild;
    },

    donutSegment(start, end, r, r0, color) {
      // eslint-disable-next-line no-param-reassign
      if (end - start === 1) end -= 0.00001;
      const a0 = 2 * Math.PI * (start - 0.25);
      const a1 = 2 * Math.PI * (end - 0.25);
      const x0 = Math.cos(a0);
      const y0 = Math.sin(a0);
      const x1 = Math.cos(a1);
      const y1 = Math.sin(a1);
      const largeArc = end - start > 0.5 ? 1 : 0;
      return [
        '<path d="M',
        r + r0 * x0,
        r + r0 * y0,
        'L',
        r + r * x0,
        r + r * y0,
        'A',
        r,
        r,
        0,
        largeArc,
        1,
        r + r * x1,
        r + r * y1,
        'L',
        r + r0 * x1,
        r + r0 * y1,
        'A',
        r0,
        r0,
        0,
        largeArc,
        0,
        r + r0 * x0,
        r + r0 * y0,
        '" fill="' + color + '" />'
      ].join(' ');
    },
    updateMarkers(layer) {
      const newMarkers = {};
      const features = this.map.querySourceFeatures(layer.source);
      // for every cluster on the screen, create an HTML marker for it (if we didn't yet),
      // and add it to the map if it's not there already
      for (let i = 0; i < features.length; i += 1) {
        const coords = features[i].geometry.coordinates;
        const props = features[i].properties;
        if (!props.cluster) continue;
        const id = props.cluster_id;

        if (!this.chartMarkers[layer.source]) {
          this.chartMarkers[layer.source] = {};
        }
        if (!this.chartMarkersOnScreen[layer.source]) {
          this.chartMarkersOnScreen[layer.source] = {};
        }

        let marker = this.chartMarkers[layer.source][id];
        if (!marker) {
          let el;
          switch (layer.chartOptions.chartCluster) {
            case 'donut':
              el = this.createDonutChart(props, layer.chartOptions.chartLegend);
              break;
            default:
              el = '<br/>';
              break;
          }
          marker = this.chartMarkers[layer.source][id] = new mapboxgl.Marker({
            element: el,
          }).setLngLat(coords);
        }
        newMarkers[id] = marker;
        if (!this.chartMarkersOnScreen[layer.source][id]) {
          marker.addTo(this.map);
        }
      }
      // for every marker we've added previously, remove those that are no longer visible
      // eslint-disable-next-line no-restricted-syntax
      for (const id in this.chartMarkersOnScreen[layer.source]) {
        if (!newMarkers[id]) this.chartMarkersOnScreen[layer.source][id].remove();
      }
      this.chartMarkersOnScreen[layer.source] = newMarkers;
    },
    updateCharts() {
      // this.updateMarkers('donut');
      this.chartLayers.forEach((l) => {
        this.updateMarkers(l);
      });
    },
    initCharts(chartlayer) {
      this.chartLayers.push(chartlayer);
      const input = {
        type: 'chart',
        layername: chartlayer.source,
        item: chartlayer.chartOptions.chartLegend,
      };
      this.$store.commit('addLegendItem', input);
      this.updateCharts();
    },
    addToLegend(conf, layer) {
      if (conf.layerType === 'overlay' && conf.addToLegend) {
        const input = {
          type: conf.layerType,
          layername: null,
          item: [{
            lStyle: conf.style,
            title: conf.name,
          }],
        };
        this.$store.commit('addLegendItem', input);
      }
    },
  },
};

</script>

<style>
.map-container {
  padding: 0;
  margin: 0;
}

  #map {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
  }

</style>
